import classes from './ConditionModal.module.css';

import { Modal } from 'react-bootstrap';
import { X } from 'react-feather';

const ConditionModal = (props) => {
	const conditions = [
		{
			name: 'Excellent',
			description: 'Shows no signs of wear - like new',
		},
		{
			name: 'Very Good',
			description: 'May show little to no signs of wear and tear.',
		},
		{
			name: 'Good',
			description:
				'May show slight traces of use in keeping with age. Most vintage and antique items fit into this condition.',
		},
		{
			name: 'Fair',
			description:
				'May show signs of previous use including scratches, chips or stains.',
		},
	];
	return (
		<Modal show={props.show} onHide={props.onHide}>
			<section className={classes.modalHeader}>
				<h1 className={classes.modalTitle}>Wear Condition</h1>
				<X
					strokeWidth={1}
					className={classes.modalClose}
					onClick={props.onHide}
				/>
			</section>
			<section className={classes.modalBody}>
				<ul className={classes.conditionList}>
					{conditions.map((condition) => (
						<li key={condition.name} className={classes.listItem}>
							<h2 className={classes.title}>{condition.name}</h2>
							<div className={classes.description}>{condition.description}</div>
						</li>
					))}
				</ul>
				<div className={classes.description}>
					Condition is often subjective and should also be judged based on the
					images and provided description. If you have specific questions, you
					can also ask the seller.
				</div>
			</section>
		</Modal>
	);
};

export default ConditionModal;
